/**
 * Recursively checks if an object and all its nested objects are empty
 * @param obj - The object to check
 * @returns true if the object and all nested objects are empty, false otherwise
 */
export function isDeepEmpty(obj: any): boolean {
  if (obj == null) {
    return true;
  }

  if (typeof obj !== "object") {
    return false;
  }

  if (Array.isArray(obj)) {
    return obj.length === 0 || obj.every(isDeepEmpty);
  }

  const keys = Object.keys(obj);
  if (keys.length === 0) {
    return true;
  }

  return keys.every((key) => {
    const value = obj[key];

    // Empty string or null/undefined values are considered empty
    if (value === "" || value === null || value === undefined) {
      return true;
    }

    // For objects, recursively check if they're empty
    if (typeof value === "object") {
      return isDeepEmpty(value);
    }

    // Non-empty primitive values
    return false;
  });
}
